import { useQuery } from "@tanstack/react-query";
import { ListBookCategoriesQueryFilters, UseListBookCategoriesQueryOptions } from "./types";
import { getBookCategoriesService  } from "./service";

export const listBookCategoriesQueryKey = ["book_category_admin"];

export function useListBookCategoriesQuery(
  filters?: ListBookCategoriesQueryFilters,
  options?: UseListBookCategoriesQueryOptions
) {
  const queryFilters = filters ? { ...filters } : undefined;

  if (queryFilters?.search) {
    delete queryFilters.ids;
  }

  const queryKey = listBookCategoriesQueryKey.concat(JSON.stringify(queryFilters));

  return useQuery({
    queryKey,
    queryFn: async () => getBookCategoriesService(filters),
    ...options,
  });
}
